import useSWR from "swr";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { EditionKind, EditionSession } from "../types";

interface UseEditionSessionsResult {
  sessions: EditionSession[];
  isLoading: boolean;
  error: any;
  mutate: () => void;
}

const SESSIONS_PATH: Record<EditionKind, string> = {
  physical: "physicalSessions",
  virtual: "virtualSessionsFlat",
};

export const useEditionSessions = (
  corporateId: string | number,
  editionId: string | number,
  kind: EditionKind,
): UseEditionSessionsResult => {
  const url =
    corporateId && editionId
      ? `${ServicesURL.getEditions}/${SESSIONS_PATH[kind]}/${editionId}?corporateId=${corporateId}`
      : null;

  const { data, isLoading, error, mutate } = useSWR(url, (u: string) =>
    fetcher<any>(u, MethodType.GET),
  );

  const sessions: EditionSession[] = Array.isArray(data)
    ? data
    : (data?.sessions ?? []);

  return { sessions, isLoading, error, mutate };
};
